import { IN_DEV } from './firebase';

export let stripe;

if (IN_DEV)
    stripe = Stripe('pk_test_51IBnqkEmGSNW2XQwlohxIdtfS7u3yynDMYuNWJ77jG978GVvIgrutlSqLOSFIPKIM3t3LfDh5tCAcphrPEXOt8FP00FSnkVOoe');
else
    stripe = Stripe('pk_live_51IBnqkEmGSNW2XQw0XXcs0yBqMep5qBBSzKg17jLopg7wbUj1tcLM6O93sH8p9SWsSwZG1OKLo6zK3WBZimMJdXH00GVxIQF0k');

